// extracted by mini-css-extract-plugin
export default {"acc-container":"PlansContainer_acc-container__e2Lox","contentHide":"PlansContainer_contentHide__RnPtj","contentShow":"PlansContainer_contentShow__j-Hxm"};